{
  "articles": [
    {
      "title": "Konsultacje z ekspertami",
      "description": "Wsparcie doświadczonych dietetyków, psychologów, trenerów i fizjoterapeutów",
      "image": "/images/articles/article-1.jpg",
      "date": "",
      "author": {
        "name": ""
      },
      "url": {
        "pl-PL" : "",
        "en-US": ""
      }
    },
    {
      "title": "Pomiary składu ciała",
      "description": "Precyzyjne dopasowanie diety i ćwiczeń do potrzeb",
      "image": "/images/articles/article-2.jpg",
      "date": "",
      "author": {
        "name": ""
      },
      "url": {
        "pl-PL" : "",
        "en-US": ""
      }
    },
    {
      "title": "Warsztaty ergonomiczne",
      "description": "Praktyczne wskazówki i ćwiczenia",
      "image": "/images/articles/article-3.jpg",
      "date": "",
      "author": {
        "name": ""
      },
      "url": {
        "pl-PL" : "",
        "en-US": ""
      }
    },
    {
      "title": "Warsztaty fizjoterapeutyczne",
      "description": "Wiedza i doświadczenie eksperta podane w przystępnej formie",
      "image": "/images/articles/article-4.jpg",
      "date": "",
      "author": {
        "name": ""
      },
      "url": {
        "pl-PL" : "",
        "en-US": ""
      }
    }
  ]
}